export const requestUserCreateStep = [
    {
    target: ".j_req_bkbtn",
    content:
      "Click on this button to go back to request table view.",
    placement: "bottom",
  },
  {
    target: ".j_req_by",
    content:
      "This shows the person who is initiating the request. It's auto-filled and cannot be changed.",
    placement: "bottom",
  },
  {
    target: ".j_req_date",
    content:
      "This shows the date of the request. It is automatically set to today.",
    placement: "bottom",
  },
  {
    target: ".j_req_for",
    content:
      "Select the user from Active Directory for whom this security request is being created.",
    placement: "bottom",
  },
  {
    target: ".j_req_ad_tgl",
    content:
      "Use this toggle to choose between Active Directory users and manual entry.",
    placement: "left",
  },
  {
    target: ".j_req_mail",
    content: "Enter the email address of the user. This is a required field.",
    placement: "bottom",
  },

  {
    target: ".j_req_mrg_tgl",
    content:
      "Enable this if you want to add selected roles to existing ones without replacing them.",
    placement: "top",
  },
];
export const reqSecurityCreate=[
    {
    target: ".j_req_t_group",
    content:
      "Choose this tab to copy roles from a security group.",
    placement: "bottom",
  },
  {
    target: ".j_req_cpy_grp",
    content:
      "To copy roles from a Security Group, select the group here.",
    placement: "bottom",
  },
  {
    target: ".j_req_t_manual", 
    content: "You are in Manual Mode. Here you can assign roles directly from each available dimension.",
    placement: "bottom",
  },
    {
    target: ".j_req_sbmt",
    content: "Click here to submit and create the security request.",
    placement: "top",
  },
]
export const reqUserCreate=[
      {
    target: ".j_req_t_user",
    content:
      "Choose this tab to copy roles from a user available in the system.",
    placement: "bottom",
  },

  {
    target: ".j_req_cpy_user",
    content:
      "To copy roles from a user, select the user here.",
    placement: "bottom",
  },

    {
    target: ".j_req_sbmt",
    content: "Click here to submit and create the security request.",
    placement: "top",
  },
]
export const reqManualCreate = [
  {
    target: ".j_req_t_manual", 
    content: "You are in Manual Mode. Here you can assign roles directly from each available dimension.",
    placement: "bottom",
  },
  {
    target: ".r_man_tabs",
    content: "These are the available dimensions. Select a dimension (like Product or Customer) to configure its roles.",
    placement: "bottom",
  },

  {
    target: ".r_man_all",
    content: "Use this toggle if you want to assign all roles from this dimension.",
    placement: "right",
  },
  {
    target: ".r_man_role", 
    content: "Click here to add another role manually for this dimension.",
    placement: "right",
  },
  {
    target: ".r_man_cond",
    content: "Click here to add more conditions for fine-grained role assignment.",
    placement: "right",
  },
    {
    target: ".j_req_sbmt",
    content: "Click here to submit and create the security request.",
    placement: "top",
  },
];

